import React from "react";
import './SimulationGalleryPage.css';

const SimulationGalleryPage = () => {
  const handleOpenSimulation = () => {
    window.open('https://simulation.colorfuel.art', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="simulationWrapper">
      {/* Background cards */}
      <div className="backgroundCards">
        <div className="backgroundCard card1">
          <img src="/assets/simulation_slide_1.png" alt="Simulation Preview 1" />
        </div>
        <div className="backgroundCard card2">
          <img src="/assets/simulation_slide_2.png" alt="Simulation Preview 2" />
        </div>
        <div className="backgroundCard card3">
          <img src="/assets/simulation_slide_3.png" alt="Simulation Preview 3" />
        </div>
      </div>
      
      {/* Overlay content */}
      <div className="simulationContent">
        <h1>ColorFuel Simulation</h1>
        <p>Connect with web3 users, artists, and creators in our immersive virtual gallery where digital art comes to life</p>
        <button 
          className="simulationButton"
          onClick={handleOpenSimulation}
        >
          Enter Simulation
        </button>
      </div>
    </div>
  );
};

export default SimulationGalleryPage;